import React from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  value?: Option | null;
  className?: string;
  styles?: any;
  onChange?: (option: Option | null) => void;
  disabled?: boolean;
}

const CommonSelectemp: React.FC<SelectProps> = ({
  options,
  value,
  className,
  styles,
  onChange,
  disabled,
}) => {
  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={value || null} // ✅ Controlled value
      onChange={onChange}   // ✅ Pass selected back to parent
      styles={styles}
      placeholder="Select"
      isDisabled={disabled}
    />
  );
};

export default CommonSelectemp;